import React from 'react';
import { Alert, Table }  from 'reactstrap';
import * as Icon from 'react-feather';
import { ConfirmModal } from '../Modals/Confirm';

export function ConfirmDeleteDiscrepancyModal(props) {
    return (
        <ConfirmModal 
            isOpen={props.isOpen}
            toggle={props.toggle} 
            handleConfirm={(e) => props.handleConfirm(props.discrepancy, e)}
            title="Delete Discrepancy?"
            confirmText="Yes, Delete Discrepancy"
            confirmColor="danger"
            confirmIcon={Icon.Trash2}
        >
            <Alert color="warning">
                <strong>Are you sure you wish to delete the following Discrepancy?</strong>
            </Alert>

            <Table bordered>
                <thead>
                    <tr>
                        <th className="col-xs-12">Discrepancy Number</th>                      
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{props.discrepancy.id}</td>
                    </tr>
                </tbody>
            </Table>
        </ConfirmModal>
    );
}